import { fetchAllPromisedData } from "../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../common/constant";

export const getEmployeeNameFromId = async (empId) => {
  const url = `${endpoint.getEmployeeDetails}/${empId}`;
  const response = await fetchAllPromisedData(url, true, false);

  if (response?.code == 200) {
    const { email_id, employeeName } = response.data;
    return employeeName;
  }

  return "";
};
